export enum InvoicesActionTypes {
  RECEIVED = 'invoices/RECEIVED',
  REQUEST = 'invoices/REQUEST',
  NEXT_RECEIVED = 'invoices/NEXT_RECEIVED',
  NEXT_REQUEST = 'invoices/NEXT_REQUEST',
  DOWNLOAD_REQUEST = 'invoices/DOWNLOAD_REQUEST',
  DOWNLOAD_SUCCESS = 'invoices/DOWNLOAD_SUCCESS',
  DOWNLOAD_ERROR = 'invoices/DOWNLOAD_ERROR',
}
